import React, { useState } from 'react';
import { Form, Input, Button, message, Typography, Card } from 'antd';
import { auth, db } from '../../firebase/config';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';
import { UserOutlined, MailOutlined, LockOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Register = ({messageApi}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f0f2f5',
      padding: '20px',
    },
    card: {
      width: '100%',
      maxWidth: '400px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      borderRadius: '8px',
    },
    header: {
      textAlign: 'center',
      marginBottom: '32px',
    },
    form: {
      padding: '24px',
    },
    loginLink: {
      textAlign: 'center',
      marginTop: '16px',
    }
  };

// Update the navigation in Register component
const onFinish = async (values) => {
  try {
    setLoading(true);
    const { email, password, username } = values;
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    
    await setDoc(doc(db, 'users', userCredential.user.uid), {
      username,
      email,
      createdAt: new Date().toISOString(),
      profileImage: `https://api.dicebear.com/7.x/initials/svg?seed=${username}`,
      votes: {},
      comments: []
    });

    await auth.signOut();
    
    messageApi.success({
      content: 'Registration successful! Please login.',
      duration: 3,
    });
    navigate('/login', { replace: true });
  } catch (error) {
    messageApi.error({
      content: 'Registration failed. Please try again.',
      duration: 3,
    });
  } finally {
    setLoading(false);
  }
};    return (
    <div style={styles.container}>
      <Card style={styles.card}>
        <div style={styles.header}>
          <Title level={2}>Register</Title>
          <Title level={4}>Create your account</Title>
        </div>

        <Form
          name="register"
          onFinish={onFinish}
          layout="vertical"
          style={styles.form}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="Username"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input 
              prefix={<MailOutlined />} 
              placeholder="Email"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Please input your password!' },
              { min: 6, message: 'Password must be at least 6 characters!' }
            ]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading} 
              block
              size="large"
            >
              Register
            </Button>
          </Form.Item>

          <div style={styles.loginLink}>
            Already have an account? <Link to="/login">Login now!</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Register;
